export default __webpack_public_path__ + "static/heroBg-c71f661360848b83115fe267d07848b1.png";